import imageRef from 'presentation/assets/images/pexels-picjumbocom-461077_small_compressed.jpg';
import TitleWithPrevPageLink from 'presentation/components/TitleWithPrevPageLink';
import { WizardStepsContainer } from 'presentation/components/WizardSteps';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import store from 'store';
import { styled } from 'styletron-react';

const ImageElement = styled('img', {
  objectFit: 'cover',
  borderTopLeftRadius: '50px',
  borderBottomRightRadius: '50px'
});

const Center = styled('div', {
  width: '380px',
  height: '240px'
});

const ConfirmEmailPage = () => {
  const { t } = useTranslation();
  const email = store.getState().onboardingInfo.contactDetails.email;

  return (
    <Container className="mb-5">
      <WizardStepsContainer />
      <TitleWithPrevPageLink title={t('confirmEmailTitle')} />

      <Row className="justify-content-center">
        <Col xs={12} md="auto" className="my-3">
          <Center className="d-flex justify-content-center mw-100 m-auto">
            <ImageElement
              src={imageRef}
              alt={t('confirmEmailSuccessImageAlt')}
              className="w-100 h-100"
            ></ImageElement>
          </Center>
        </Col>
        <Col xs={12} md="auto" className="my-3">
          <Center className="d-flex justify-content-center mw-100 m-auto">
            <div>
              <p>
                <Trans
                  i18nKey="confirmEmailParagraph1"
                  tOptions={{ skipPostProcessing: true }}
                  components={[
                    <span
                      data-gi="e-mail-address"
                      dangerouslySetInnerHTML={{
                        __html: email
                      }}
                    ></span>
                  ]}
                ></Trans>
              </p>
              <p>
                <Trans i18nKey={'confirmEmailParagraph2'} />
              </p>
              <p>{t('confirmEmailParagraph3')}</p>
            </div>
          </Center>
        </Col>
      </Row>
    </Container>
  );
};

export default ConfirmEmailPage;
